import { render, staticRenderFns } from "./dailyreportstatistic copy.vue?vue&type=template&id=637e85bc&"
import script from "./dailyreportstatistic copy.vue?vue&type=script&lang=js&"
export * from "./dailyreportstatistic copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports